<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - ' + routeName" />
    </div>
    <div class="margin-informes">
      <h4 class="color-secundary">
        Base operaciones
      </h4>
      <br />
      <Qlik />
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseOperacionesV2",
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    Qlik: () => import("@/components/Qlik.vue"),
  },
  computed: {
    routeName() {
      return this.$router.currentRoute.name;
    },
  },
};
</script>
